import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Cookies from "js-cookie";
import { RootState } from '../../redux/store';
import { ignoreCall } from '../../redux/slices/webSocketSlice';
import styles from './CallNotificationWidget.module.css';
import { CallNotification } from '../../types/meeting.types';
import { sanitizeUserId } from '../../common/utility/sanitizeUserId';
import { fetchAllRoomDetails, fetchRoomDetails } from './CallNotificationFunction';
import useJwtToken from '../../config/auth/useJwtToken';
import { environment } from '../../config/environments/environment';


type RoomNameMap = { [roomId: string]: string };

// --- Execute the function ---


export const CallNotificationWidget: React.FC = () => {
  const dispatch = useDispatch();
  const activeCalls = useSelector((state: RootState) => state.activeCalls.activeCalls);
  const [roomNames, setRoomNames] = useState<RoomNameMap>({});
  const [roomDetails, setDetails] = useState<any[]>([]);
  const [expanded, setExpanded] = useState<boolean>(true)
  const authUser = useJwtToken();
  const accessToken = authUser?.matrixAccessToken;
  const authToken: string | undefined = Cookies.get("auth_token");

  useEffect(() => {
    const loadRoomNames = async () => {
      const names: RoomNameMap = {};

      await Promise.all(
        activeCalls.map(async (call) => {
          try {
            const nameData = await fetchRoomDetails(call.roomId, accessToken);
            names[call.roomId] = nameData?.name || null;
          } catch (error) {
            console.error(`Failed to fetch name for room ${call.roomId}:`, error);
            names[call.roomId] = '[Error]';
          }
        })
      );

      setRoomNames(names);
    };

    if (activeCalls.length > 0) {
      loadRoomNames();
    }
  }, [activeCalls]);

  useEffect(() => {
    const loadRoomNames = async () => {

      await Promise.all(
        activeCalls.map(async (call) => {
          try {
            const roomDetails = await fetchAllRoomDetails(accessToken, call?.roomId);
            const Opponant = roomDetails.filter((participant) => !participant.isMe);
            setDetails(Opponant);
          } catch (error) {
            console.error(`Failed to fetch name for room ${call.roomId}:`, error);
          }
        })
      );
    };

    if (activeCalls.length > 0) {
      loadRoomNames();
    }
  }, [activeCalls]);

  if (activeCalls.length === 0) return null;

  const handleJoinCall = async (call: CallNotification) => {
    const response = await fetch(`${process.env.REACT_APP_NOTIFICATION_URL}/api/chat-meeting/room/${sanitizeUserId(call.roomId)}`);

    const data = await response.json();
    if (data?.oneToOneCall) {
      window.open(`${environment["elementFrontendUrl"]}#/jwt=${authToken}/userId=${authUser?.user?.ID}/roomId=!${call.roomId}:${call.matrixServerName}`, '_blank');
    } else {
      window.open(data.meetingUrl, '_blank');
    }
    dispatch(ignoreCall(call));
  };

  const handleIgnoreCall = (call: CallNotification) => {
    dispatch(ignoreCall(call));
  };

  const toggleExpanded = (): void => {
    setExpanded(!expanded);
  };

  if (activeCalls.length === 1) {
    return (
      <div className={styles.mx_single_ActiveCalls}>
        {activeCalls.map((call) => {
          const name = roomNames[call.roomId]
          const singleCallName = roomDetails?.[0]?.content?.displayname

          return (
            <div key={call.roomId} className={styles.mx_single_Active_Call_Notification}>
              {!name ? <img src='images/single_call_icon.svg' className={styles.mx_callIcon} /> : <img src='images/group_call_icon.svg' className={styles.mx_callIcon} />}
              <div className={styles.mx_callInfo}>
                <div>
                  <h4>{name ? name : singleCallName}</h4>
                  <div className={styles.mx_callType}>
                    <img src='images/video-camera.svg' className={styles.mx_videoCamerIcon} />
                    <p> {!name ? '1 to 1 call' : 'Group call'}</p>
                  </div>
                </div>
              </div>
              <div className={styles.mx_callAction}>
                <button
                  className={styles.mx_joinButton}
                  onClick={() => handleJoinCall(call)}
                >
                  Join Call
                </button>
                <button
                  className={styles.mx_ignoreButton}
                  onClick={() => handleIgnoreCall(call)}
                >
                  Ignore Call
                </button>
              </div>
              <div className={styles.mx_callCloseIcon}>
                <img src='images/close.svg' onClick={() => handleIgnoreCall(call)} />
              </div>
            </div>
          )
        })}
      </div>
    )
  }

  return (
    <div className={styles.mx_ActiveCallsWidget}>

      <div
        className={`${styles.mx_ActiveCallsWidget_header} ${expanded ? styles.expand : ''}`}
        onClick={toggleExpanded}
      >
        <div className={styles.mx_headingRightBlock}>
          <img src="images/call.svg" alt="" className={styles.mx_ActiveCallsWidget_icon} />
          <h4 className={styles.mx_ActiveCallsWidget_title}>{"Active Calls"}</h4>
          <span className={styles.mx_ActiveCallsWidget_count}>
            ({activeCalls.length < 10 ? `0${activeCalls.length}` : activeCalls.length})
          </span>
        </div>
        <img src="images/down.svg" alt="" className={styles.mx_downButton} />
      </div>



      {expanded && (
        <div className={styles.mx_ActiveCallsWidget_content} >
          {activeCalls.map((call, index) => {
            const name = roomNames[call.roomId]
            const singleCallName = roomDetails?.[0]?.content?.displayname

            return <div key={call.roomId} className={styles.mx_single_Active_Call_Notification}>
              {!name ? <img src='images/single_call_icon.svg' className={styles.mx_callIcon} /> : <img src='images/group_call_icon.svg' className={styles.mx_callIcon} />}
              <div className={styles.mx_callInfo}>
                <div>
                  <h4>{name ? name : singleCallName}</h4>
                  <div className={styles.mx_callType}>
                    <img src='images/video-camera.svg' className={styles.mx_videoCamerIcon} />
                    <p> {!name ? '1 to 1 call' : 'Group call'}</p>
                  </div>
                </div>
              </div>
              <div className={styles.mx_callAction}>
                <button
                  className={styles.mx_joinButton}
                  onClick={() => handleJoinCall(call)}
                >
                  Join Call
                </button>
                <button
                  className={styles.mx_ignoreButton}
                  onClick={() => handleIgnoreCall(call)}
                >
                  Ignore Call
                </button>
              </div>
            </div>
          })}
        </div>
      )}
    </div>
  );
};
